function _array_like_to_array(arr, len) {
    if (len == null || len > arr.length) len = arr.length;
    for(var i = 0, arr2 = new Array(len); i < len; i++)arr2[i] = arr[i];
    return arr2;
}
function _array_with_holes(arr) {
    if (Array.isArray(arr)) return arr;
}
function _define_property(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function _iterable_to_array_limit(arr, i) {
    var _i = arr == null ? null : typeof Symbol !== "undefined" && arr[Symbol.iterator] || arr["@@iterator"];
    if (_i == null) return;
    var _arr = [];
    var _n = true;
    var _d = false;
    var _s, _e;
    try {
        for(_i = _i.call(arr); !(_n = (_s = _i.next()).done); _n = true){
            _arr.push(_s.value);
            if (i && _arr.length === i) break;
        }
    } catch (err) {
        _d = true;
        _e = err;
    } finally{
        try {
            if (!_n && _i["return"] != null) _i["return"]();
        } finally{
            if (_d) throw _e;
        }
    }
    return _arr;
}
function _non_iterable_rest() {
    throw new TypeError("Invalid attempt to destructure non-iterable instance.\\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
function _object_spread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            _define_property(target, key, source[key]);
        });
    }
    return target;
}
function _object_without_properties(source, excluded) {
    if (source == null) return {};
    var target = _object_without_properties_loose(source, excluded);
    var key, i;
    if (Object.getOwnPropertySymbols) {
        var sourceSymbolKeys = Object.getOwnPropertySymbols(source);
        for(i = 0; i < sourceSymbolKeys.length; i++){
            key = sourceSymbolKeys[i];
            if (excluded.indexOf(key) >= 0) continue;
            if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue;
            target[key] = source[key];
        }
    }
    return target;
}
function _object_without_properties_loose(source, excluded) {
    if (source == null) return {};
    var target = {};
    var sourceKeys = Object.keys(source);
    var key, i;
    for(i = 0; i < sourceKeys.length; i++){
        key = sourceKeys[i];
        if (excluded.indexOf(key) >= 0) continue;
        target[key] = source[key];
    }
    return target;
}
function _sliced_to_array(arr, i) {
    return _array_with_holes(arr) || _iterable_to_array_limit(arr, i) || _unsupported_iterable_to_array(arr, i) || _non_iterable_rest();
}
function _to_primitive(input, hint) {
    if (_type_of(input) !== "object" || input === null) return input;
    var prim = input[Symbol.toPrimitive];
    if (prim !== undefined) {
        var res = prim.call(input, hint || "default");
        if (_type_of(res) !== "object") return res;
        throw new TypeError("@@toPrimitive must return a primitive value.");
    }
    return (hint === "string" ? String : Number)(input);
}
function _to_property_key(arg) {
    var key = _to_primitive(arg, "string");
    return _type_of(key) === "symbol" ? key : String(key);
}
function _type_of(obj) {
    "@swc/helpers - typeof";
    return obj && typeof Symbol !== "undefined" && obj.constructor === Symbol ? "symbol" : typeof obj;
}
function _unsupported_iterable_to_array(o, minLen) {
    if (!o) return;
    if (typeof o === "string") return _array_like_to_array(o, minLen);
    var n = Object.prototype.toString.call(o).slice(8, -1);
    if (n === "Object" && o.constructor) n = o.constructor.name;
    if (n === "Map" || n === "Set") return Array.from(n);
    if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _array_like_to_array(o, minLen);
}
import deepmerge from '@mui/utils/deepmerge';
import cssVarsParser from "./cssVarsParser.js";
function prepareCssVars(theme) {
    var parserConfig = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : {};
    var _parserConfig_getSelector = parserConfig.getSelector, getSelector = _parserConfig_getSelector === void 0 ? defaultGetSelector : _parserConfig_getSelector, disableCssColorScheme = parserConfig.disableCssColorScheme, selector = parserConfig.colorSchemeSelector;
    // @ts-ignore - ignore components do not exist
    var _theme_colorSchemes = theme.colorSchemes, colorSchemes = _theme_colorSchemes === void 0 ? {} : _theme_colorSchemes, components = theme.components, _theme_defaultColorScheme = theme.defaultColorScheme, defaultColorScheme = _theme_defaultColorScheme === void 0 ? 'light' : _theme_defaultColorScheme, otherTheme = _object_without_properties(theme, [
        "colorSchemes",
        "components",
        "defaultColorScheme"
    ]);
    var _cssVarsParser = cssVarsParser(otherTheme, parserConfig), rootVars = _cssVarsParser.vars, rootCss = _cssVarsParser.css, rootVarsWithDefaults = _cssVarsParser.varsWithDefaults;
    var themeVars = rootVarsWithDefaults;
    var colorSchemesMap = {};
    var defaultScheme = colorSchemes[defaultColorScheme], otherColorSchemes = _object_without_properties(colorSchemes, [
        defaultColorScheme
    ].map(_to_property_key));
    Object.entries(otherColorSchemes || {}).forEach(function(param) {
        var _param = _sliced_to_array(param, 2), key = _param[0], scheme = _param[1];
        var _cssVarsParser = cssVarsParser(scheme, parserConfig), vars = _cssVarsParser.vars, css = _cssVarsParser.css, varsWithDefaults = _cssVarsParser.varsWithDefaults;
        themeVars = deepmerge(themeVars, varsWithDefaults);
        colorSchemesMap[key] = {
            css: css,
            vars: vars
        };
    });
    if (defaultScheme) {
        // default color scheme vars should be merged last to set as default
        var _cssVarsParser1 = cssVarsParser(defaultScheme, parserConfig), css = _cssVarsParser1.css, vars = _cssVarsParser1.vars, varsWithDefaults = _cssVarsParser1.varsWithDefaults;
        themeVars = deepmerge(themeVars, varsWithDefaults);
        colorSchemesMap[defaultColorScheme] = {
            css: css,
            vars: vars
        };
    }
    function defaultGetSelector(colorScheme, cssObject) {
        var rule = selector;
        if (selector === 'class') {
            rule = '.%s';
        }
        if (selector === 'data') {
            rule = '[data-%s]';
        }
        if ((selector === null || selector === void 0 ? void 0 : selector.startsWith('data-')) && !selector.includes('%s')) {
            // 'data-joy-color-scheme' -> '[data-joy-color-scheme="%s"]'
            rule = "[".concat(selector, '="%s"]');
        }
        if (colorScheme) {
            if (rule === 'media') {
                var _colorSchemes_colorScheme_palette, _colorSchemes_colorScheme;
                if (theme.defaultColorScheme === colorScheme) {
                    return ':root';
                }
                var mode = ((_colorSchemes_colorScheme = colorSchemes[colorScheme]) === null || _colorSchemes_colorScheme === void 0 ? void 0 : (_colorSchemes_colorScheme_palette = _colorSchemes_colorScheme.palette) === null || _colorSchemes_colorScheme_palette === void 0 ? void 0 : _colorSchemes_colorScheme_palette.mode) || colorScheme;
                return _define_property({}, "@media (prefers-color-scheme: ".concat(mode, ")"), {
                    ':root': cssObject
                });
            }
            if (rule) {
                if (theme.defaultColorScheme === colorScheme) {
                    return ":root, ".concat(rule.replace('%s', String(colorScheme)));
                }
                return rule.replace('%s', String(colorScheme));
            }
        }
        return ':root';
    }
    var generateThemeVars = function() {
        var vars = _object_spread({}, rootVars);
        Object.entries(colorSchemesMap).forEach(function(param) {
            var _param = _sliced_to_array(param, 2), _param_ = _param[1], schemeVars = _param_.vars;
            vars = deepmerge(vars, schemeVars);
        });
        return vars;
    };
    var generateStyleSheets = function() {
        var insertStyleSheet = function insertStyleSheet(key, css) {
            if (Object.keys(css).length) {
                stylesheets.push(typeof key === 'string' ? _define_property({}, key, _object_spread({}, css)) : key);
            }
        };
        var stylesheets = [];
        var colorScheme = theme.defaultColorScheme || 'light';
        insertStyleSheet(getSelector(undefined, _object_spread({}, rootCss)), rootCss);
        var defaultSchemeVal = colorSchemesMap[colorScheme], other = _object_without_properties(colorSchemesMap, [
            colorScheme
        ].map(_to_property_key));
        if (defaultSchemeVal) {
            var _colorSchemes_colorScheme_palette, _colorSchemes_colorScheme;
            // default color scheme has to come before other color schemes
            var css = defaultSchemeVal.css;
            var cssColorSheme = (_colorSchemes_colorScheme = colorSchemes[colorScheme]) === null || _colorSchemes_colorScheme === void 0 ? void 0 : (_colorSchemes_colorScheme_palette = _colorSchemes_colorScheme.palette) === null || _colorSchemes_colorScheme_palette === void 0 ? void 0 : _colorSchemes_colorScheme_palette.mode;
            var finalCss = !disableCssColorScheme && cssColorSheme ? _object_spread({
                colorScheme: cssColorSheme
            }, css) : _object_spread({}, css);
            insertStyleSheet(getSelector(colorScheme, _object_spread({}, finalCss)), finalCss);
        }
        Object.entries(other).forEach(function(param) {
            var _param = _sliced_to_array(param, 2), key = _param[0], css = _param[1].css;
            var _colorSchemes_key_palette, _colorSchemes_key;
            var cssColorSheme = (_colorSchemes_key = colorSchemes[key]) === null || _colorSchemes_key === void 0 ? void 0 : (_colorSchemes_key_palette = _colorSchemes_key.palette) === null || _colorSchemes_key_palette === void 0 ? void 0 : _colorSchemes_key_palette.mode;
            var finalCss = !disableCssColorScheme && cssColorSheme ? _object_spread({
                colorScheme: cssColorSheme
            }, css) : _object_spread({}, css);
            insertStyleSheet(getSelector(key, _object_spread({}, finalCss)), finalCss);
        });
        return stylesheets;
    };
    return {
        vars: themeVars,
        generateThemeVars: generateThemeVars,
        generateStyleSheets: generateStyleSheets
    };
}
export default prepareCssVars;
